import { render, staticRenderFns } from "./UrnRepositoryOrder.vue?vue&type=template&id=59703222&"
import script from "./UrnRepositoryOrder.vue?vue&type=script&lang=js&"
export * from "./UrnRepositoryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports